import { useState } from 'react';

const projects = [
  {
    title: 'Retail Shopping Center',
    location: 'Edmond, OK',
    service: 'Sealcoating & Striping',
    description: 'Complete parking lot renovation including sealcoating, restriping, and ADA compliance updates for a 250-space retail center.',
    image: 'https://public.readdy.ai/ai/img_res/ad420072159f85bd485159fbdd8b5d7a.jpg',
    category: 'Sealcoating'
  },
  {
    title: 'Medical Office Complex',
    location: 'Oklahoma City, OK',
    service: 'ADA Compliance Striping',
    description: 'Updated all handicap spaces, access aisles, and signage to meet current ADA requirements for a busy medical facility.',
    image: 'https://readdy.ai/api/search-image?query=medical%20office%20building%20parking%20lot%20with%20ADA%20compliant%20handicap%20spaces%2C%20blue%20painted%20accessibility%20markings%20and%20wheelchair%20symbols%2C%20professional%20striping%20work%2C%20healthcare%20facility%20parking%20area%2C%20clear%20organized%20layout%2C%20commercial%20property%20compliance&width=800&height=600&seq=project-002&orientation=landscape',
    category: 'Striping'
  },
  {
    title: 'Corporate Office Park',
    location: 'Norman, OK',
    service: 'Crack Sealing & Repair',
    description: 'Preventative maintenance including comprehensive crack sealing and pothole repair to extend pavement life.',
    image: 'https://readdy.ai/api/search-image?query=corporate%20office%20park%20parking%20lot%20after%20crack%20sealing%20and%20repair%20work%2C%20smooth%20black%20asphalt%20surface%20with%20sealed%20cracks%2C%20professional%20pavement%20preservation%2C%20business%20campus%20parking%20area%2C%20quality%20maintenance%20results%2C%20commercial%20property%20care&width=800&height=600&seq=project-003&orientation=landscape',
    category: 'Repair'
  },
  {
    title: 'Apartment Complex',
    location: 'Moore, OK',
    service: 'Full Lot Striping',
    description: 'Complete restriping of resident and visitor parking spaces, including fire lanes and directional arrows.',
    image: 'https://readdy.ai/api/search-image?query=apartment%20complex%20parking%20lot%20with%20fresh%20yellow%20line%20striping%2C%20residential%20property%20parking%20spaces%20clearly%20marked%2C%20fire%20lane%20red%20markings%2C%20professional%20striping%20work%2C%20multi%20family%20housing%20parking%20area%2C%20organized%20layout&width=800&height=600&seq=project-004&orientation=landscape',
    category: 'Striping'
  },
  {
    title: 'Restaurant & Bar District',
    location: 'Oklahoma City, OK',
    service: 'Sealcoating',
    description: 'High-traffic parking area sealcoating to protect against oil stains and weather damage.',
    image: 'https://readdy.ai/api/search-image?query=restaurant%20and%20entertainment%20district%20parking%20lot%20with%20fresh%20black%20sealcoating%2C%20commercial%20dining%20area%20parking%2C%20protected%20asphalt%20surface%2C%20urban%20commercial%20property%2C%20professional%20sealcoat%20application%2C%20high%20traffic%20area%20maintenance&width=800&height=600&seq=project-005&orientation=landscape',
    category: 'Sealcoating'
  },
  {
    title: 'Industrial Warehouse',
    location: 'Midwest City, OK',
    service: 'Loading Zone Striping',
    description: 'Custom striping for loading docks, truck routes, and employee parking areas.',
    image: 'https://readdy.ai/api/search-image?query=industrial%20warehouse%20parking%20lot%20and%20loading%20zone%20with%20yellow%20striping%2C%20commercial%20truck%20route%20markings%2C%20loading%20dock%20area%20pavement%20markings%2C%20industrial%20facility%20parking%2C%20professional%20commercial%20striping%2C%20logistics%20center%20layout&width=800&height=600&seq=project-006&orientation=landscape',
    category: 'Striping'
  },
  {
    title: 'Church Campus',
    location: 'Edmond, OK',
    service: 'Complete Maintenance',
    description: 'Full parking lot maintenance including sealcoating, striping, and crack repair for large church campus.',
    image: 'https://readdy.ai/api/search-image?query=church%20campus%20parking%20lot%20with%20fresh%20sealcoating%20and%20striping%2C%20large%20religious%20facility%20parking%20area%2C%20well%20maintained%20asphalt%20surface%2C%20organized%20parking%20spaces%2C%20community%20property%20maintenance%2C%20professional%20pavement%20care&width=800&height=600&seq=project-007&orientation=landscape',
    category: 'Sealcoating'
  },
  {
    title: 'School District Facility',
    location: 'Yukon, OK',
    service: 'Safety Striping',
    description: 'Crosswalks, bus zones, and parent pickup area striping for enhanced safety.',
    image: 'https://readdy.ai/api/search-image?query=school%20parking%20lot%20with%20safety%20striping%20and%20crosswalks%2C%20educational%20facility%20parking%20area%2C%20bus%20zone%20markings%2C%20parent%20pickup%20area%20striping%2C%20pedestrian%20safety%20markings%2C%20school%20campus%20pavement%20markings&width=800&height=600&seq=project-008&orientation=landscape',
    category: 'Striping'
  },
  {
    title: 'HOA Community Center',
    location: 'Mustang, OK',
    service: 'Parking Lot Refresh',
    description: 'Sealcoating and restriping to improve appearance and property value for HOA community.',
    image: 'https://readdy.ai/api/search-image?query=HOA%20community%20center%20parking%20lot%20with%20fresh%20sealcoating%2C%20residential%20community%20facility%20parking%2C%20well%20maintained%20asphalt%20surface%2C%20homeowners%20association%20property%2C%20professional%20pavement%20maintenance%2C%20neighborhood%20amenity%20parking&width=800&height=600&seq=project-009&orientation=landscape',
    category: 'Sealcoating'
  }
];

const categories = ['All', 'Sealcoating', 'Striping', 'Repair'];

export default function WorkGallery() {
  const [activeCategory, setActiveCategory] = useState('All');

  const filteredProjects = activeCategory === 'All' 
    ? projects 
    : projects.filter(p => p.category === activeCategory);

  return (
    <section className="py-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Filter Tabs */}
        <div className="flex flex-wrap justify-center gap-3 mb-16">
          {categories.map((category) => (
            <button
              key={category}
              onClick={() => setActiveCategory(category)}
              className={`px-6 py-3 rounded-full font-semibold transition-all whitespace-nowrap cursor-pointer ${
                activeCategory === category
                  ? 'bg-yellow-400 text-black'
                  : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
              }`}
            >
              {category}
            </button>
          ))}
        </div>

        {/* Projects Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {filteredProjects.map((project, index) => (
            <div
              key={index}
              className="group cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-2xl mb-4">
                <img
                  src={project.image}
                  alt={project.title}
                  className="w-full h-64 object-cover object-top transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                  <p className="text-sm text-gray-200">{project.description}</p>
                </div>
                <span className="absolute top-4 left-4 px-3 py-1 bg-yellow-400 text-black text-xs font-bold rounded-full">
                  {project.service}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                {project.title}
              </h3>
              <p className="text-gray-600 flex items-center">
                <i className="ri-map-pin-line text-yellow-500 mr-2"></i>
                {project.location}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-16">
          <p className="text-xl text-gray-600 mb-6">
            Ready to transform your parking lot?
          </p>
          <a
            href="#quote"
            className="inline-flex items-center justify-center px-8 py-4 bg-yellow-400 text-black font-bold rounded-lg hover:bg-yellow-500 transition-all whitespace-nowrap cursor-pointer"
          >
            Get Your Free Quote
            <i className="ri-arrow-right-line ml-2 text-xl"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
